define([
    'lodash',
    'gridComponent/helpers/filtering',
    'gridComponent/core/enums'
],
function (_, filtering, Enums) {
    'use strict';

    function filterStaticData(rows, filter) {
        let processedRows = rows;
        if (!_.isUndefined(filter)) {
            processedRows = _.filter(rows, filter);
        }

        return {
            rows: processedRows,
            rowsCount: processedRows.length
        };
    }

    function State() {
        return {
            dataFetchContext: null,
            dataFetchHandler: null,
            uiState: null,
            agGridApi: null,
            currentPage: undefined
        };
    }

    State.setGrid = function (state, agGridModule, gridOptions, gridNode) {
        State.destroyGrid(state);
        // You gotta love ag-grid ...
        // eslint-disable-next-line no-new
        new agGridModule.Grid(gridNode, gridOptions);
        state.agGridApi = gridOptions.api; // eslint-disable-line santa/no-side-effects
        return state;
    };

    State.destroyGrid = function (state) {
        if (state.agGridApi !== null) {
            state.agGridApi.destroy();
            state.agGridApi = null;
        }
        return state;
    };

    State.setDataSource = function (state, dataSource) {
        state.agGridApi.setDatasource(dataSource);
        return state;
    };

    State.setRowData = function (state, rows, filter) {
        const filterMethod = filtering.buildFilter(filter);
        const filteredRows = filterStaticData(rows, filterMethod);
        state.agGridApi.setRowData(filteredRows.rows);
        return state;
    };

    State.updateUsingApi = function (state, callMap) {
        _.forEach(callMap, function (args, methodName) {
            state.agGridApi[methodName].apply(state.agGridApi, args);
        });
        return state;
    };

    State.displayOverlay = function (state, displayType) {
        state.agGridApi[displayType]();
        return state;
    };

    State.setDataFetchHandler = function (state, handler) {
        state.dataFetchHandler = handler; // eslint-disable-line santa/no-side-effects
        return state;
    };

    State.handleFetchedData = function (state, data) {
        if (state.dataFetchHandler !== null) {
            let dataClone = _.clone(data);
            const dataFetchHandler = state.dataFetchHandler;
            if (_.has(dataFetchHandler, 'startRow')) {
                // static, needs filtering and page slicing
                dataClone = filterStaticData(data.rows, dataFetchHandler.filter);
                dataClone.rows = _.slice(dataClone.rows, dataFetchHandler.startRow, dataFetchHandler.endRow);
            }
            dataFetchHandler.successCallback(dataClone.rows, dataClone.rowsCount);
            state.dataFetchHandler = null;
        }
        return state;
    };

    State.updateUIState = function (state, value, property) {
        if (state.uiState === null) {
            state.uiState = {};
        }
        state.uiState[property] = value;
        return state;
    };

    State.restoreUIState = function (state, callMap) {
        return State.updateUsingApi(state, callMap);
    };

    State.saveCurrentPage = function (state) {
        state.currentPage = state.agGridApi.paginationController.currentPage; // eslint-disable-line santa/no-side-effects
        return state;
    };

    State.setCurrentPage = function (state, pageNumber) {
        state.agGridApi.paginationController.currentPage = pageNumber;
        state.agGridApi.paginationController.loadPage();
        return state;
    };

    State.restoreCurrentPage = function (state) {
        if (_.isUndefined(state.currentPage)) {
            return state;
        }
        return State.setCurrentPage(state, state.currentPage);
    };

    State.isInCurrentPage = function (state, props, index) {
        const pageSize = props.compData.rows.length;
        if (props.compProp.pagination.type !== Enums.PaginationType.PAGES && index <= pageSize) {
            return true;
        }
        const rowsPerPage = props.compProp.pagination.rowsPerPage,
            currentPage = state.agGridApi.paginationController.currentPage,
            startRow = rowsPerPage * currentPage;
        let endRow;
        if (props.compData.dataSource.type === Enums.DataSourceType.STATIC) {
            endRow = pageSize;
        } else {
            endRow = rowsPerPage * currentPage + pageSize; // eslint-disable-line no-mixed-operators
        }
        return startRow <= index && index < endRow;
    };

    return State;
}
);
